import { render, staticRenderFns } from "./Resumo.vue?vue&type=template&id=66b6c986&scoped=true"
import script from "./Resumo.vue?vue&type=script&lang=js"
export * from "./Resumo.vue?vue&type=script&lang=js"
import style0 from "./Resumo.vue?vue&type=style&index=0&id=66b6c986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b6c986",
  null
  
)

export default component.exports